import React from 'react';
//import Navigation from '../Navigation/';

import withRoot from './modules/withRoot';
// --- Post bootstrap -----
import ProductCategories from './modules/views/ProductCategories';
import ProductSmokingHero from './modules/views/ProductSmokingHero';
import AppFooter from './modules/views/AppFooter';
import ProductHero from './modules/views/ProductHero';
import ProductValues from './modules/views/ProductValues';
import ProductHowItWorks from './modules/views/ProductHowItWorks';
import ProductCTA from './modules/views/ProductCTA';
import AppAppBar from './modules/views/AppAppBar';

/*
const Landing = () => (
  <div>
    <h1>Landing</h1>
    <Navigation />
  </div>
);

export default Landing;
*/
const LANGUAGES = [
  {
    code: 'in-IN',
    name: 'Indonesia',
  },
  {
    code: 'en-US',
    name: 'English',
  },
];

function Landing() {
  const [appLanguage, setAppLanguage] = React.useState("");
  return (
    <React.Fragment>
      <AppAppBar language={appLanguage} LANGUAGES={LANGUAGES} onLanguageChange={(event)=>{setAppLanguage(event.target.value)}}/>
      <ProductHero language={appLanguage}/>
      <ProductValues language={appLanguage}/>
      <ProductCategories language={appLanguage}/>
      <ProductHowItWorks language={appLanguage}/>
      <ProductCTA language={appLanguage}/>
      <ProductSmokingHero language={appLanguage}/>
      <AppFooter language={appLanguage} LANGUAGES={LANGUAGES} onLanguageChange={(event)=>{setAppLanguage(event.target.value)}}/>
    </React.Fragment>
  );
}

export default withRoot(Landing);